// ✅ src/components/admin/AdminScreen.js
import React, { useEffect, useState } from "react";
import { auth, db } from "../../lib/firebase";
import { doc, getDoc } from "firebase/firestore";

import AdminHomeScreen from "./AdminHomeScreen";
import AdminProductsScreen from "./AdminProductsScreen";
import AdminUsersScreen from "./AdminUsersScreen";
import AdminReportsScreen from "./AdminReportsScreen";
import AdminNotificationsScreen from "./AdminNotificationsScreen";
import AdminPaymentsScreen from "./AdminPaymentsScreen";

// ✅ FIX: support screen is in SAME folder
import AdminSupportInboxScreen from "./AdminSupportInboxScreen";

export default function AdminScreen({ goBack }) {
  const [tab, setTab] = useState("home");
  const [role, setRole] = useState("");
  const [loadingRole, setLoadingRole] = useState(true);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const u = auth.currentUser;

        if (!u) {
          if (alive) {
            setRole("");
            setLoadingRole(false);
          }
          return;
        }

        const snap = await getDoc(doc(db, "stores", u.uid));
        const store = snap.exists() ? snap.data() : null;

        const r = String(store?.role || "").toLowerCase().trim();
        const isAdminBool = store?.isAdmin === true;

        if (!alive) return;
        setRole(isAdminBool ? "admin" : r);
      } catch (e) {
        console.log("ADMIN ROLE LOAD ERROR:", e);
        if (!alive) return;
        setRole("");
      } finally {
        if (alive) setLoadingRole(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (loadingRole) return <div style={{ padding: 16 }}>Loading…</div>;

  const backHome = () => setTab("home");

  // ✅ tabs
  if (tab === "products") return <AdminProductsScreen goBack={backHome} role={role} />;
  if (tab === "users") return <AdminUsersScreen goBack={backHome} role={role} />;
  if (tab === "reports") return <AdminReportsScreen goBack={backHome} role={role} />;
  if (tab === "notifications") return <AdminNotificationsScreen goBack={backHome} role={role} />;
  if (tab === "payments") return <AdminPaymentsScreen goBack={backHome} role={role} />;
  if (tab === "support") return <AdminSupportInboxScreen goBack={backHome} role={role} />;

  return (
    <AdminHomeScreen
      goBack={goBack}
      role={role}
      onOpenProducts={() => setTab("products")}
      onOpenUsers={() => setTab("users")}
      onOpenReports={() => setTab("reports")}
      onOpenNotifications={() => setTab("notifications")}
      onOpenPayments={() => setTab("payments")}
      onOpenSupport={() => setTab("support")} // ✅ this was missing before
    />
  );
}
